import { Injectable } from '@angular/core';
import { PriceBoxUpdateArgument } from '../model/price-box-update-event-argument';
import { TrackingUpdateEventArgument } from '../model/tracking-update-event-argument';

declare var jQuery: any;

@Injectable({
  providedIn: 'root'
})
export class PriceBoxCommunicationService {

  private TARIFF_UPDATE_EVENT_NAME = 'tariffUpdated';
  private TRACKING_UPDATE_EVENT_NAME = 'trackingDataUpdated';
  private TRACKING_ATTRIBUTES_UPDATE_EVENT_NAME = 'tariffTrackingAttributesUpdated';

  private JQUERY_TARIFF_BOX_SELECTOR = '#VV_TariffBox';

  constructor() { }

  triggerPriceUpdate(args: Array<PriceBoxUpdateArgument>, contextType: ContextType) {
    const eventData: any = {
      tariffUpdates: args,
      context: contextType
    };

    jQuery(this.JQUERY_TARIFF_BOX_SELECTOR).trigger(this.TARIFF_UPDATE_EVENT_NAME, eventData);
  }

  triggerTrackingUpdate(arg: TrackingUpdateEventArgument, contextType: ContextType, trackingAttributesString: string) {
    jQuery(this.JQUERY_TARIFF_BOX_SELECTOR).trigger(this.TRACKING_UPDATE_EVENT_NAME, arg);
    jQuery(this.JQUERY_TARIFF_BOX_SELECTOR).trigger(this.TRACKING_ATTRIBUTES_UPDATE_EVENT_NAME, {
      trackingAttributesString,
      context: contextType
    });
  }
}

export enum ContextType {
  UKV = 'ukv',
  BK = 'bk',
  VMK = 'vmk'
}
